<script lang="ts" setup>
import { ISingleSystemSetupParameter, TaskTypeDescription } from '@/api/generator';
import QaSectionGroupParameter from '@/views/tasks/components/QaSectionGroupParameter.vue';
import { useFieldValue } from 'vee-validate';
import { computed, toRef } from 'vue';

const { name } = defineProps<{
  name: string;
  taskType: TaskTypeDescription;
}>();

const singleSetupParameters = useFieldValue<ISingleSystemSetupParameter[]>(toRef(() => name));

const hasAnyEnabledParameter = computed(() =>
  singleSetupParameters.value?.some((elem) => elem?.isEnabled),
);
</script>

<template>
  <div v-show="hasAnyEnabledParameter" class="parameter-grid">
    <template v-for="(parameter, index) in singleSetupParameters" :key="parameter.id">
      <QaSectionGroupParameter :name="`${name}[${index}]`" />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.parameter-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px 16px;
  width: 100%;

  .single-setup-parameter {
    width: 100%;
  }
}
</style>
